module Tapas.Bindings {
    export class ScrollToElement {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            var value = valueAccessor();
            var ele = $(element);
            var target = $(value.target)[0];
            var targetPos = target.getBoundingClientRect().top + window.scrollY - 120;
            ele.click(function (e) {
                e.stopPropagation();
                e.preventDefault();
                window.scroll({
                    top: targetPos,
                    behavior: 'smooth'
                });
            });
        }
    }
    ko.bindingHandlers['scrollToElement'] = new ScrollToElement();
} 
